import api from './client';

export const createCheckout = async (postId) => {
  const res = await api.post(`/posts/${postId}/checkout`);
  return res.data;
};

export const getCheckoutSession = async (sessionId) => {
  const res = await api.get(`/checkout/${sessionId}`);
  return res.data;
};

export const confirmCheckout = async (sessionId) => {
  const res = await api.post(`/checkout/${sessionId}/confirm`);
  return res.data;
};

export const cancelCheckout = async (sessionId) => {
  const res = await api.post(`/checkout/${sessionId}/cancel`);
  return res.data;
};

export const getWallet = async () => {
  const res = await api.get('/wallet');
  return res.data;
};

export const requestPayout = async (amount) => {
  const res = await api.post('/wallet/payout', amount ? { amount } : {});
  return res.data;
};

export const adminListUsers = async (q = '') => {
  const res = await api.get('/admin/users', { params: q ? { q } : {} });
  return res.data;
};

export const adminUpdateFee = async (userId, fee) => {
  const res = await api.patch(`/admin/users/${userId}/fee`, {
    platform_fee_percentage: fee,
  });
  return res.data;
};

export const adminStats = async () => {
  const res = await api.get('/admin/stats');
  return res.data;
};

export const adminListPayouts = async () => {
  const res = await api.get('/admin/payouts');
  return res.data;
};

export const adminUpdatePayout = async (payoutId, status) => {
  const res = await api.patch(`/admin/payouts/${payoutId}`, { status });
  return res.data;
};
